// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__jxQFq","author":"Table_author__32eHu","authorImage":"Table_authorImage__1MMpu","unreadRow":"Table_unreadRow__4DiIH"};